import styled from 'styled-components';
import React from 'react';

export type CommonLoaderProps = {
  loaderType?: 'main' | 'inner';
  circleSize?: string;
  thickness?: String;
  className?: string;
};
export const MainLoader = ({
  loaderType,
  circleSize,
  thickness,
  className,
}: CommonLoaderProps) => {
  return (
    <Wrapper
      loaderType={loaderType}
      circleSize={circleSize}
      thickness={thickness}
      className={className}
    >
      <div className="loader-container">
        <div className="loader"></div>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div<CommonLoaderProps>`
  position: absolute;
  height: 100%;
  width: 100%;
  &.home-loader {
    .loader-container {
      background-color: #ffffff24;
    }
  }
  .loader-container {
    position: ${({ loaderType }) =>
      loaderType === 'main' ? 'absolute' : 'relative'};
    background-color: #7987cb30;
    height: 100%;
    width: 100%;
    top: 50%;
    left: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10300;
    transform: translate(-50%, -50%);
    position: fixed;
  }

  .loader {
    border: ${({ thickness }) => (thickness ? `${thickness}px` : '8px')} solid
      rgba(0, 0, 0, 0.1);
    border-left-color: #7986cb; /* Change color as needed */
    border-radius: 50%;

    width: ${({ circleSize }) => (circleSize ? `${circleSize}px` : '40px')};
    height: ${({ circleSize }) => (circleSize ? `${circleSize}px` : '40px')};
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;
